var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"xl":"8"}},[_c('mail-preferences-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }